import { Box, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { doGetInvoiceSummaryAsync, selectInvoice, selectSummary } from './correctionInvoiceEditorSlice';
import { NumericFormat } from 'react-number-format';
import MDTypography from 'components/MDTypography';
import BillzTypography from 'components/BillzTypographies/BillzTypography';
import BillzTypographyTitle from 'components/BillzTypographies/BillzTypographyTitle';
export default function ShortCorrectionInvoiceSummaryPanel(props) {
  const dispatch = useDispatch();

  const invoice = useSelector(selectInvoice);
  const summary = useSelector(selectSummary);

  React.useEffect(() => {
    const payload = {
      items: invoice.items,
      currency: invoice.currency,
    };

    dispatch(doGetInvoiceSummaryAsync(payload));
  }, [invoice.items]);

  const IsPositive = (value) => {
    if (value !== undefined && value.length > 0 && value[0] === '-') {
      return false;
    }

    return true;
  }

  const MakePositive = (value) => {
    if (IsPositive(value) === false) {
      return value.replace('-', '')
    }

    return value;
  }

  return (
    <Box style={{ marginLeft: 'auto' }}>
      <Stack direction="row" flexGrow={1} sx={{ mt: 3 }}>
        <Stack direction="column">
          <BillzTypography color="text" width={150} align="right">
            Suma netto:
          </BillzTypography>
          <BillzTypography color="text" width={150} align="right">
            Suma VAT:
          </BillzTypography>
          <BillzTypographyTitle color="text" width={150} align="right">
            {IsPositive(summary.grossTotal) ? 'Do zapłaty:' : 'Do zwrotu:'}
          </BillzTypographyTitle>
        </Stack>
        <Stack direction="column" sx={{ ml: 1, mr: 2, flex: 1, whiteSpace: 'nowrap' }}>
          <BillzTypography color="text" align="right">
            {summary.netTotal}
          </BillzTypography>
          <BillzTypography color="text" align="right">
            {summary.taxTotal}
          </BillzTypography>
          <BillzTypographyTitle color="text" align="right">
            {MakePositive(summary.grossTotal)}
          </BillzTypographyTitle>
        </Stack>
      </Stack>
    </Box>
  );
}
